import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  UnrealGameFirstPerson,
  UnrealGameRole,
  UnrealGameRealTime,
  UnrealGameOpenWorld,
  UnrealGameBattle,
  UnrealGameHorror,
  UnrealGameRacing,
  UnrealGameMultiplayer,
} from "../../../app-constants-updated";
import BgImg from "../../images/services-usa/unreal-game-update/immersive_game.webp";

function Immersiveunrealgame() {
  return (
    <section
      className="immersive_unreal_game p-100 text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <h2>
              Diverse Genre <span>Expertise for Immersive Unreal Game</span>{" "}
              Development Services
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <p>
              Our Unreal Engine game development services span a wide range of
              game genres. From complex gameplay mechanics to high-fidelity
              visual environments, our focus is on delivering precision and
              immersive experiences.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="unreal_game_main">
              <div className="unreal_game_item">
                <div className="unreal_game_icon">{UnrealGameFirstPerson}</div>
                <div className="unreal_head">
                  <h5>
                    First-Person
                    <br /> Shooter (FPS)
                  </h5>
                </div>
              </div>
              <div className="unreal_game_item">
                <div className="unreal_game_icon">{UnrealGameRole}</div>
                <div className="unreal_head">
                  <h5>
                    Role-Playing
                    <br /> Game (RPG)
                  </h5>
                </div>
              </div>
              <div className="unreal_game_item">
                <div className="unreal_game_icon">{UnrealGameRealTime}</div>
                <div className="unreal_head">
                  <h5>
                    Real-Time
                    <br /> Strategy (RTS)
                  </h5>
                </div>
              </div>
              <div className="unreal_game_item">
                <div className="unreal_game_icon">{UnrealGameOpenWorld}</div>
                <div className="unreal_head">
                  <h5>
                    Open-World
                    <br /> Adventure
                  </h5>
                </div>
              </div>
              <div className="unreal_game_item">
                <div className="unreal_game_icon">{UnrealGameBattle}</div>
                <div className="unreal_head">
                  <h5>Battle Royale</h5>
                </div>
              </div>
              <div className="unreal_game_item">
                <div className="unreal_game_icon">{UnrealGameHorror}</div>
                <div className="unreal_head">
                  <h5>Horror Survival</h5>
                </div>
              </div>
              <div className="unreal_game_item">
                <div className="unreal_game_icon">{UnrealGameRacing}</div>
                <div className="unreal_head">
                  <h5>Racing Simulator</h5>
                </div>
              </div>
              <div className="unreal_game_item">
                <div className="unreal_game_icon">{UnrealGameMultiplayer}</div>
                <div className="unreal_head">
                  <h5>Multiplayer Online Battle Arena (MOBA)</h5>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Immersiveunrealgame;
